// extracted by mini-css-extract-plugin
module.exports = {"Accreditation":"Accreditation_Accreditation__2lAoV","AccreditationContainer":"Accreditation_AccreditationContainer__2sYbP"};